export class MenuItem {

    constructor(title: string, icon: string, uiSref?: string, uiSrefAlias?: string) {
        this.title = title;
        this.uiSref = uiSref;
        this.uiSrefAlias = uiSrefAlias;
        this.icon = icon;
        this.childMenuItems = [];
        this.isChildMenuOpen = false;
    }

    public title: string;

    public uiSref: string;

    public uiSrefAlias: string;

    public icon: string;

    public isSelected: boolean;

    public isChildMenuOpen: boolean;

    public parent: MenuItem;

    public childMenuItems: MenuItem[];

    public get hasChildren(): boolean {
        return this.childMenuItems != null && this.childMenuItems.length != 0;
    }

    public get isSvg(): boolean {
        return !!this.icon && this.icon.toLowerCase().endsWith(".svg");
    }

    public toggleChildMenu(isVisible?: boolean): void {
        if (this.hasChildren) {
            if (isVisible != null) {
                this.isChildMenuOpen = isVisible;
            } else {
                this.isChildMenuOpen = !this.isChildMenuOpen;
            }
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/model/menu.item.ts